const SESSION_KEY = 'smart-capture-session-id';

/** One session id per app launch, attached to every capture so the
 * server can group a run's captures (capture-app.html CA-06 note 1).
 * Persisted in sessionStorage: a new tab or a fresh install starts a new
 * session, a reload within the same tab keeps the operator's run intact. */
export function getSessionId(): string {
  if (typeof window === 'undefined') return 'server';
  const existing = window.sessionStorage.getItem(SESSION_KEY);
  if (existing) return existing;
  const created = crypto.randomUUID();
  window.sessionStorage.setItem(SESSION_KEY, created);
  return created;
}
